// Main entry point — imports SCSS and all JS parts
import '../scss/styles.scss';
import './parts/icons'; // must be static — runs before framework DOM scan

// ============================================================================
// Site-wide modules (statically imported — run on every page)
// ============================================================================
import footerLinks from './parts/footer-links';
import urlClean from './parts/url';
import secondaryNavMobileHover from './parts/secondary-nav-mobile-hover';
import flickityFallback from './parts/flickity-fallback';
import closeNavOnOutsideClick from './parts/close-nav-on-outside-click';

// ============================================================================
// Page-specific modules (lazy-loaded — only fetched when selector exists)
// ============================================================================
// Each key is a CSS selector. If it matches an element on the page, the
// corresponding chunk is fetched and initialized. Otherwise no request is made.
const lazyParts = {
  '.updater-qualform-form':  () => import(/* webpackChunkName: "qual-form-hotfix" */     './parts/qual-form-hotfix'),
  '.gauge-cont':             () => import(/* webpackChunkName: "speed-gauge" */          './parts/speed-gauge'),
};

// ============================================================================
// Initialize on DOM ready
// ============================================================================
jQuery(function ($) {
  // Run site-wide modules
  footerLinks($);
  urlClean($);
  secondaryNavMobileHover();
  flickityFallback();
  closeNavOnOutsideClick();

  // Selectors whose chunks should wait until the user scrolls (heavy libs
  // that are in the initial viewport but not needed for LCP).
  var deferUntilScroll = new Set(['#growthImageMobile-1', '.growth-tab']);

  // Lazy-load page-specific modules only when their selectors exist
  Object.entries(lazyParts).forEach(function ([selector, loader]) {
    if (!document.querySelector(selector)) return;

    if (deferUntilScroll.has(selector)) {
      // Defer import until the user actually scrolls so the chunk
      // doesn't compete with LCP on first paint.
      window.addEventListener('scroll', function () {
        loader().then(function (mod) { mod.default($); });
      }, { once: true, passive: true });
    } else {
      loader().then(function (mod) { mod.default($); });
    }
  });
});
